<template>
    <div>
        <aside class="search-btn">
            <vButtonGroup class="tablelist-tabs clearfix" compact>
                <vButton
                    size="large"
                    v-for="(item, index) in btnsearch"
                    :key="index"
                    :theme="
                        formData.itemstatus === item.value
                            ? 'primary'
                            : 'default'
                    "
                    @click="handleBtn('status', item.value)"
                    >{{ item.label }}</vButton
                >
            </vButtonGroup>
            <!--  费用对比汇总 -->
            <compCostall v-if="formData.itemstatus == 1"></compCostall>
            <!-- 费用对比明细 -->
            <compCostdetail v-if="formData.itemstatus == 0"></compCostdetail>
        </aside>
    </div>
</template>
<script>
import compCostall from "./shipmanage.js";
import compCostdetail from "./shipdetail.js";

export default {
    components: {
        compCostall,
        compCostdetail,
    },
    data() {
        return {
            formData: {
                itemstatus: 1,
            },
        };
    },
    computed: {
        btnsearch() {
            return [
                {
                    value: 1,
                    label: this.$t("fbb.billDelivery.summary", {
                        defaultValue: "账单汇总",
                    }),
                },
                {
                    value: 0,
                    label: this.$t("fbb.billDelivery.detail", {
                        defaultValue: "账单明细",
                    }),
                },
            ];
        },
    },
    methods: {
        handleBtn(type, value) {
            // console.log(2222)
            this.formData.itemstatus = value;
        },
    },
};
</script>
